export default __webpack_public_path__ + "static/media/ezgif.com-gif-maker.9ae5dcc8.gif";